import React from 'react';
import { Check, X } from 'lucide-react';
export const ComparisonSection = () => {
  return <section className="w-full bg-white px-5 py-10" data-id="element-74">
      <div className="max-w-md mx-auto" data-id="element-75">
        <h2 className="text-2xl font-bold text-pink-900 mb-7 text-center leading-tight" data-id="element-76">
          What Most Dryness "Solutions" Get Wrong vs. What Nuora Does Right:
        </h2>
        <div className="flex flex-col md:flex-row mb-8 rounded-xl overflow-hidden shadow-sm" data-id="element-77">
          <div className="w-full md:w-1/2 bg-gray-100 p-5" data-id="element-78">
            <h3 className="font-bold text-gray-800 mb-5 text-center text-lg" data-id="element-79">
              Other Solutions
            </h3>
            <div className="space-y-4" data-id="element-80">
              <ComparisonItemNegative title="Lubricants" points={['Messy', 'Temporary', 'Kills spontaneity']} data-id="element-81" />
              <ComparisonItemNegative title="Hormonal Creams" points={['Side effects', 'Prescription needed']} data-id="element-82" />
              <ComparisonItemNegative title="Other Probiotics" points={['Die in stomach acid']} data-id="element-83" />
            </div>
          </div>
          <div className="w-full md:w-1/2 bg-pink-50 p-5" data-id="element-84">
            <h3 className="font-bold text-pink-800 mb-5 text-center text-lg" data-id="element-85">
              Nuora
            </h3>
            <div className="space-y-3" data-id="element-86">
              <ComparisonItemPositive text="Works from within" data-id="element-87" />
              <ComparisonItemPositive text="Addresses the root cause" data-id="element-88" />
              <ComparisonItemPositive text="All-natural & hormone-free" data-id="element-89" />
              <ComparisonItemPositive text="Rebuilds the entire ecosystem" data-id="element-90" />
            </div>
          </div>
        </div>
        <a href="https://mynuora.com/products/feminine-balance-gummies-1" target="_blank" rel="noopener noreferrer" data-id="element-91">
          <button className="bg-pink-600 hover:bg-pink-700 transition-colors text-white font-bold py-4 px-6 rounded-full w-full shadow-md" data-id="element-92">
            GET NUORA GUMMIES NOW
          </button>
        </a>
      </div>
    </section>;
};
interface ComparisonItemNegativeProps {
  title: string;
  points: string[];
}
const ComparisonItemNegative = ({
  title,
  points
}: ComparisonItemNegativeProps) => {
  return <div className="bg-white rounded-xl p-4 shadow-sm" data-id="element-93">
      <p className="font-semibold text-gray-800 mb-3" data-id="element-94">{title}</p>
      <div className="space-y-2" data-id="element-95">
        {points.map((point, i) => <div key={i} className="flex items-center" data-id="element-96">
            <X className="h-4 w-4 text-red-500 mr-2.5 flex-shrink-0" data-id="element-97" />
            <p className="text-sm text-gray-700" data-id="element-98">{point}</p>
          </div>)}
      </div>
    </div>;
};
const ComparisonItemPositive = ({
  text
}: {
  text: string;
}) => {
  return <div className="bg-white rounded-xl p-4 shadow-sm flex items-center" data-id="element-99">
      <Check className="h-5 w-5 text-green-500 mr-2.5 flex-shrink-0" data-id="element-100" />
      <p className="text-base font-medium text-gray-800" data-id="element-101">{text}</p>
    </div>;
};